import React from 'react';
import type { ColDef, EditableCallbackParams } from 'ag-grid-community';
import { LopCrudPage } from '../../components/LopCrudPage';
import { getCreditRiskTypes, saveBatchCreditRiskTypes } from '../../api/creditRiskTypes';
import type { CreditRiskType } from '../../types/CreditRiskType';
import { t } from '../../i18n/t';

const columnDefs: ColDef<CreditRiskType>[] = [
  {
    field: 'creditRiskTypeId',
    headerName: t('creditRiskTypes.columns.creditRiskTypeId'),
    width: 120,
    cellDataType: 'number',
    editable: (params: EditableCallbackParams<CreditRiskType>) =>
      (params.data as { __status?: string } | undefined)?.__status === 'added',
    sort: 'asc',
  },
  {
    field: 'creditRiskTypeName',
    headerName: t('creditRiskTypes.columns.creditRiskTypeName'),
    flex: 1,
    editable: true,
  },
  {
    field: 'creditRiskTypeId4Rashut',
    headerName: t('creditRiskTypes.columns.creditRiskTypeId4Rashut'),
    width: 160,
    cellDataType: 'number',
    editable: true,
  },
];

const newRowDefaults = (): Partial<CreditRiskType> => ({
  creditRiskTypeId: 0,
  creditRiskTypeName: '',
  creditRiskTypeId4Rashut: null,
});

export function CreditRiskTypesPage() {
  return (
    <LopCrudPage<CreditRiskType>
      resourceCode="creditRiskTypes"
      titleKey="creditRiskTypes.pageTitle"
      idField="creditRiskTypeId"
      getRows={getCreditRiskTypes}
      saveBatch={(added, modified, deletedIds) =>
        saveBatchCreditRiskTypes(added, modified, deletedIds as number[])
      }
      columnDefs={columnDefs}
      newRowDefaults={newRowDefaults}
    />
  );
}
